import {
  fToCurrency,
  getArticlePriceData,
  getInventoryArticleType,
} from '@web/utils/src';

interface ItemPriceProps {
  article: any;
  className?: string;
}

const ItemPrice = (props: ItemPriceProps) => {
  const { article, className } = props;

  const itemType = getInventoryArticleType(article);
  const amount = article.amount || 1;

  const { basePrice, finalPrice } = getArticlePriceData(article);
  const countableDisplayPrice =
    (finalPrice / amount) * (article.comparisonAmount || 1);

  if (!basePrice) return null;

  return (
    <div className={className}>
      <p className="text-4-0 md:text-2-0 font-bd" role="finalPrice">
        {fToCurrency(finalPrice || 0)}
      </p>
      <div className="text-2-0 md:text-1-2" role="subPrice">
        {itemType === 'countable' && (
          <p>
            {fToCurrency(countableDisplayPrice)} /{article.unit}
          </p>
        )}
        {itemType === 'loose' && (
          <p>
            / {article.amount} {article.unit}
          </p>
        )}
      </div>
    </div>
  );
};

export default ItemPrice;
